import { OPERATION_RIGHTS } from "./operationRights";

export const USER_ROLES = {
  NO_ROLE: "",
  OWNER: "59b30942-24c6-4b95-89e9-ffdac90e3b08",
  ADMIN: "4d2a0251-81bd-4319-8b60-09b167a3d037", // can do everything except subscription and removal of an account
  MEMBER: "9cd73213-29e1-4719-97ec-6a90d01c5e25",
  SUPPORT_AGENT: "3c300e9f-8f31-4603-9013-8a48400f2d48",
  VIEWER: "6becf910-76be-431b-bc13-f2d167bb3ea6",
};

export const MANAGER_ROLES = [USER_ROLES.OWNER, USER_ROLES.ADMIN];

export const ALL_ROLES = [
  USER_ROLES.OWNER,
  USER_ROLES.ADMIN,
  USER_ROLES.MEMBER,
  USER_ROLES.SUPPORT_AGENT,
  USER_ROLES.VIEWER,
];

export const MAIN_ROLES_WHO_CAN_EDIT = [
  USER_ROLES.OWNER,
  USER_ROLES.ADMIN,
  USER_ROLES.MEMBER,
];

export const ENTITIES = {
  FORMS: "FORMS",
  SUBMISSIONS: "SUBMISSIONS",
  CONNECTORS: "CONNECTORS",
  WORKFLOWS: "WORKFLOWS",
  LOOKUP_DICTIONARIES: "LOOKUP_DICTIONARIES",
  LOOKUP_DICTIONARY_ITEMS: "LOOKUP_DICTIONARY_ITEMS",
  ACCOUNT_EMAILS: "ACCOUNT_EMAILS",
  EMAIL_LAYOUTS: "EMAIL_LAYOUTS",
  EMAIL_TEMPLATES: "EMAIL_TEMPLATES",
  USER_INVITATIONS: "USER_INVITATIONS",
  USERS: "USERS",
};

export const FULL_RIGHTS = [
  OPERATION_RIGHTS.CREATE,
  OPERATION_RIGHTS.UPDATE,
  OPERATION_RIGHTS.REMOVE,
  OPERATION_RIGHTS.PRINT,
  OPERATION_RIGHTS.IMPORT,
  OPERATION_RIGHTS.EXPORT,
];

export const USER_ROLE_RIGHTS_ENTITIES = {
  [USER_ROLES.OWNER]: {
    [ENTITIES.FORMS]: FULL_RIGHTS,
    [ENTITIES.SUBMISSIONS]: FULL_RIGHTS,
    [ENTITIES.CONNECTORS]: FULL_RIGHTS,
    [ENTITIES.WORKFLOWS]: FULL_RIGHTS,
    [ENTITIES.LOOKUP_DICTIONARIES]: FULL_RIGHTS,
    [ENTITIES.LOOKUP_DICTIONARY_ITEMS]: FULL_RIGHTS,
    [ENTITIES.ACCOUNT_EMAILS]: FULL_RIGHTS,
    [ENTITIES.EMAIL_LAYOUTS]: FULL_RIGHTS,
    [ENTITIES.EMAIL_TEMPLATES]: FULL_RIGHTS,
    [ENTITIES.USER_INVITATIONS]: FULL_RIGHTS,
    [ENTITIES.USERS]: FULL_RIGHTS,
  },
  [USER_ROLES.ADMIN]: {
    [ENTITIES.FORMS]: FULL_RIGHTS,
    [ENTITIES.SUBMISSIONS]: FULL_RIGHTS,
    [ENTITIES.CONNECTORS]: FULL_RIGHTS,
    [ENTITIES.WORKFLOWS]: FULL_RIGHTS,
    [ENTITIES.LOOKUP_DICTIONARIES]: FULL_RIGHTS,
    [ENTITIES.LOOKUP_DICTIONARY_ITEMS]: FULL_RIGHTS,
    [ENTITIES.ACCOUNT_EMAILS]: FULL_RIGHTS,
    [ENTITIES.EMAIL_LAYOUTS]: FULL_RIGHTS,
    [ENTITIES.EMAIL_TEMPLATES]: FULL_RIGHTS,
    [ENTITIES.USER_INVITATIONS]: FULL_RIGHTS,
    [ENTITIES.USERS]: FULL_RIGHTS,
  },
  [USER_ROLES.MEMBER]: {
    [ENTITIES.FORMS]: FULL_RIGHTS,
    [ENTITIES.SUBMISSIONS]: FULL_RIGHTS,
    [ENTITIES.CONNECTORS]: FULL_RIGHTS,
    [ENTITIES.WORKFLOWS]: FULL_RIGHTS,
    [ENTITIES.LOOKUP_DICTIONARIES]: FULL_RIGHTS,
    [ENTITIES.LOOKUP_DICTIONARY_ITEMS]: FULL_RIGHTS,
    [ENTITIES.ACCOUNT_EMAILS]: FULL_RIGHTS,
    [ENTITIES.EMAIL_LAYOUTS]: [],
    [ENTITIES.EMAIL_TEMPLATES]: FULL_RIGHTS,
    [ENTITIES.USER_INVITATIONS]: [],
    [ENTITIES.USERS]: [],
  },
  [USER_ROLES.SUPPORT_AGENT]: {
    [ENTITIES.FORMS]: [],
    [ENTITIES.SUBMISSIONS]: FULL_RIGHTS,
    [ENTITIES.CONNECTORS]: [],
    [ENTITIES.WORKFLOWS]: [],
    [ENTITIES.LOOKUP_DICTIONARIES]: [],
    [ENTITIES.LOOKUP_DICTIONARY_ITEMS]: [],
    [ENTITIES.ACCOUNT_EMAILS]: [],
    [ENTITIES.EMAIL_LAYOUTS]: [],
    [ENTITIES.EMAIL_TEMPLATES]: [],
    [ENTITIES.USER_INVITATIONS]: [],
    [ENTITIES.USERS]: [],
  },
  [USER_ROLES.VIEWER]: {
    [ENTITIES.FORMS]: [],
    [ENTITIES.SUBMISSIONS]: [],
    [ENTITIES.CONNECTORS]: [],
    [ENTITIES.WORKFLOWS]: [],
    [ENTITIES.LOOKUP_DICTIONARIES]: [],
    [ENTITIES.LOOKUP_DICTIONARY_ITEMS]: [],
    [ENTITIES.ACCOUNT_EMAILS]: [],
    [ENTITIES.EMAIL_LAYOUTS]: [],
    [ENTITIES.EMAIL_TEMPLATES]: [],
    [ENTITIES.USER_INVITATIONS]: [],
    [ENTITIES.USERS]: [],
  },
};
